import React from "react";
import { Button, Row, Tooltip } from "antd";
import { useSelector, RootStateOrAny } from "react-redux";
import { PlusCircleFilled } from "@ant-design/icons";
import AccountOrgNameVersionsTable from "./AccountOrgNameVersionsTable";
import AccountInfoVersionsTable from "./AccountInfoVersionsTable";
import { AccountTypeVersionsTable } from "./AccountTypeVersionsTable";
import AccountExiteIdVersionsTable from "./AccountExiteIdVersionsTable";
import AccountPropertiesVersionsTable from "./AccountPropertiesVersionsTable";
import AccountEmailsVersionsTable from "./AccountEmailsVersionsTable";
import AccountAddressVersionsTable from "./AccountAddressVersionsTable";
import AccountPhonesVersionsTable from "./AccountPhonesVersionsTable";
import { AccountResponsibleUserTable } from "./AccountResponsibleUserTable";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import { hasLocalAccessNode } from "../../lib/configs";

interface IProps {
  getAccount: any;
  changeOrganizationVersion: any;
  closeOrganizationVersion: any;
  getAccountOrganizationVersions: any;
  closeAccountVersion: any;
  changeAccountVersion: any;
  getAccountVersions: any;
  changeExiteIdOpenedModal: any;
  fetchSubscriberVersions: any;
  handleCreateSubscriberVersion: any;
  handleCloseSubscriberVersion: any;
  // checkExiteId: any;
  // startReprocess: any;
  // checkAndStartReprocess: any;
  getPropertyVersions: any;
  changeEmailOpenedModal: any;
  fetchEmailVersions: any;
  handleCreateEmailVersion: any;
  changeAddressVersion: any;
  closeAddressVersion: any;
  fetchAddressVersions: any;
  handleCloseEmailVersion: any;
  handleCreateSubscriberVersionLoading: any;
}

function OrganizationAccountInfo(props: IProps) {
  const {
    changeOrganizationVersion,
    closeOrganizationVersion,
    getAccountOrganizationVersions,
    getAccount,
    changeAccountVersion,
    closeAccountVersion,
    getAccountVersions,
    changeExiteIdOpenedModal,
    fetchSubscriberVersions,
    handleCloseSubscriberVersion,
    // startReprocess,
    handleCreateSubscriberVersion,
    handleCreateSubscriberVersionLoading,
    // checkExiteId,
    changeAddressVersion,
    changeEmailOpenedModal,
    // checkAndStartReprocess,
    closeAddressVersion,
    fetchAddressVersions,
    fetchEmailVersions,
    getPropertyVersions,
    handleCreateEmailVersion,
    handleCloseEmailVersion,
  } = props;
  const { accountStatusesLoading, accountTypesLoading } = useSelector(
    (state: RootStateOrAny) => state.dicts
  );
  return (
    <>
      {checkIsLoaded(accountStatusesLoading, accountTypesLoading) && (
        <>
          <h4 style={{ marginTop: "50px" }}>Наименование организации</h4>
          <AccountOrgNameVersionsTable
            getAccount={getAccount}
            changeOrganizationVersion={changeOrganizationVersion}
            closeOrganizationVersion={closeOrganizationVersion}
            getAccountOrganizationVersions={getAccountOrganizationVersions}
          />
          {hasLocalAccessNode("account.read.accountType", <AccountTypeVersionsTable />)}
          <h4 style={{ marginTop: "50px" }}>Информация об аккаунте</h4>
          <AccountInfoVersionsTable
            getAccount={getAccount}
            changeOrganizationVersion={changeOrganizationVersion}
            closeOrganizationVersion={closeOrganizationVersion}
            closeAccountVersion={closeAccountVersion}
            changeAccountVersion={changeAccountVersion}
            getAccountVersions={getAccountVersions}
          />
          {hasLocalAccessNode(
            "account.read.exiteId",
            <>
              <Row align="middle" style={{ marginTop: "50px" }}>
                <h4 style={{ margin: 0 }}>Технический ID</h4>
                <Tooltip title="Добавить Технический ID">
                  <Button
                    style={{ color: "#00BB77", marginLeft: "15px", border: "none" }}
                    shape="circle"
                    icon={<PlusCircleFilled />}
                    onClick={changeExiteIdOpenedModal}
                  />
                </Tooltip>
              </Row>
              <AccountExiteIdVersionsTable
                fetchSubscriberVersions={fetchSubscriberVersions}
                handleCreateSubscriberVersion={handleCreateSubscriberVersion}
                handleCreateSubscriberVersionLoading={handleCreateSubscriberVersionLoading}
                handleCloseSubscriberVersion={handleCloseSubscriberVersion}
                // checkExiteId={checkExiteId}
                // startReprocess={startReprocess}
                // checkAndStartReprocess={checkAndStartReprocess}
              />
            </>
          )}
          {hasLocalAccessNode(
            "account.read.requisites",
            <>
              <h4 style={{ marginTop: "50px" }}>Реквизиты</h4>
              <AccountPropertiesVersionsTable
                getAccount={getAccount}
                changeOrganizationVersion={changeOrganizationVersion}
                closeOrganizationVersion={closeOrganizationVersion}
                getPropertyVersions={getPropertyVersions}
              />
            </>
          )}
          <AccountPhonesVersionsTable />
          <Row align="middle" style={{ marginTop: "50px" }}>
            <h4 style={{ margin: 0 }}>Электронная почта</h4>
            <Tooltip title="Добавить электронную почту">
              <Button
                style={{ color: "#00BB77", marginLeft: "15px", border: "none" }}
                shape="circle"
                icon={<PlusCircleFilled />}
                onClick={changeEmailOpenedModal}
              />
            </Tooltip>
          </Row>
          <AccountEmailsVersionsTable
            fetchEmailVersions={fetchEmailVersions}
            handleCreateEmailVersion={handleCreateEmailVersion}
            handleCloseEmailVersion={handleCloseEmailVersion}
          />
          <h4 style={{ marginTop: "50px" }}>Адрес</h4>
          <AccountAddressVersionsTable
            getAccount={getAccount}
            changeOrganizationVersion={changeOrganizationVersion}
            closeOrganizationVersion={closeOrganizationVersion}
            changeAddressVersion={changeAddressVersion}
            closeAddressVersion={closeAddressVersion}
            fetchAddressVersions={fetchAddressVersions}
            addressType="legalAddress"
          />
          <AccountAddressVersionsTable
            getAccount={getAccount}
            changeOrganizationVersion={changeOrganizationVersion}
            closeOrganizationVersion={closeOrganizationVersion}
            changeAddressVersion={changeAddressVersion}
            closeAddressVersion={closeAddressVersion}
            fetchAddressVersions={fetchAddressVersions}
            addressType="actualAddress"
          />
          {hasLocalAccessNode("account.read.responsibleUsers", <AccountResponsibleUserTable />)}
        </>
      )}
    </>
  );
}

export default OrganizationAccountInfo;
